import { Component, OnInit, HostListener } from '@angular/core';
import { GlobalsService, ToolboxService } from './shared/services';
import { MUser } from './shared/models/user.model';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalLogoutComponent } from './shared/components';
import { SieniService } from './shared/services/sieni.service';
import { Router } from '@angular/router';
import { MToolboxDashboard } from './shared/models/ToolboxDashboard.model';
import { SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  slideMenu = 'slide-close';
  user: MUser = null;
  public collapse: boolean = true;
  public closeMenus: boolean = true;
  public isDropOpen: boolean = false;
  public width:number = 0;
  public dropdownControl: boolean = true;
  public hover:boolean = false;
  public imgSrc:string = null;
  public environment: SafeResourceUrl;
  public toolbox: MToolboxDashboard = null;
  public imgUrl: string = null
  userSub: Subscription;
  // @HostListener('scroll', ['$event']) onScroll(event:any){
  //   console.log(event)
  // }

  onscroll(event: any){
    // console.log(event)
  }

  constructor(
      private globals: GlobalsService,
      private modalService: NgbModal,
      public activeModal: NgbActiveModal,
      private _globalService: SieniService,
      private router: Router,
      private translate: TranslateService
  ) {}

  ngOnInit() {
    this._globalService.getSettings('site','logo').subscribe((res : any)=>  this.imgUrl =  environment.imgUrl + '/storage/' + res.data);
    this.userSub = this._globalService.getCurrentUser.subscribe((data)=>{
      if(data){
        this.user = data;
        this.translate.use(this.user.language.code.toLowerCase())
        this.imgSrc = environment.imgUrl + '/storage/' + this.user.avatar;
        this._globalService.getCurrentToolbox().then(res=>{
          this.toolbox = new MToolboxDashboard(res)
        })
      }
    },(error)=>{
      this.userSub = undefined;
      console.error(error);
    });

  }

 /* setUser(user: MUser){
    console.log('pasando por aca...');
    if (user) {
      this.user = user
      this.translate.use(user.language.code)
      this.imgSrc = this.globals.imgUrl + '/storage/' + user.avatar;
      if (!this.toolbox) {
        this._globalService.getToolboxById(1).subscribe(({data}:any)=>{
          this.toolbox = new MToolboxDashboard(data)
          if (!this.toolbox.allowed) {
            this.logOut()
          }
        })
      }
    } else {
        this.imgSrc = null;
    }
    // console.log(user)
    // console.log(this.imgSrc)
    this.user = user
  }
*/
 /* setToolbox(newTool: MToolboxDashboard){
    this.toolbox = newTool
  }*/

  public dropdown(){
    if (this.dropdownControl) {
      this.dropdownControl = false;
      this.isDropOpen = !this.isDropOpen
      setTimeout(()=>{
        this.dropdownControl = true;
      }, 5)
    }
  }

  public closeAllMenus(){
    if (this.collapse){
      this.closeMenus = !this.closeMenus
    }
  }

  public closeChildren(){
     // console.log(this.width)
    if (this.width < 768) {
      this.setCollapse()
    }
  }

  public setCollapse(){
    this.collapse = !this.collapse
  }

  logOut() {
    this.isDropOpen = false;
    this.user = null;
    this._globalService.setOrg(null)
    this._globalService.setUser(null)
    this.router.navigate(['/auth', 'login'])
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', centered: true}).result.then((result) => {
      // console.log(result)
      this.logOut()
    }, (reason) => {
      // console.log(reason)
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  public updateImg(){
    this.imgSrc = this.environment + '/storage/' + this.user.avatar + "?updatedAt=" + Date.now()
  }

  ngOnDestroy(): void {
    console.log('destroyyyy');
    this.userSub = undefined;
  }
}
